import { ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export const PageHeader = ({ title, subtitle, actions }: PageHeaderProps) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems="start"
      width="100%"
      rowGap={2}
    >
      <Stack gap={1}>
        <Typography variant="h1">{title}</Typography>
        <Typography component="p" color="textSecondary">
          {subtitle}
        </Typography>
      </Stack>
      <Stack gap={1} direction="row" alignItems="center">
        {actions}
      </Stack>
    </Stack>
  );
};
